module.exports = __webpack_public_path__ + "85bd577ffc6bfacc06d5eb61f2095874.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/payments/your-transactions-null.svg
// module id = 2959
// module chunks = 0 1